module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/hidden-keys.js
// module id = 48
// module chunks = 0